/*
 *
 * @desc: 电池相关规则
 * @author: haifn
 * @time: 2020/1/13 10:40
 *
 */

// 备注
// 中国大陆、中国香港、中国澳门地区：无限制
// 中国台湾、其他地区：
// 1、电池（包含任意配件）
// 2、电池（不包含当前品类对应的充电座）
// 3、电池（不包含当前品类对应的相机）
// 续航电池包等同于电池

const NORMAL_COUNTRY_CODE = ['CN', 'HK', 'MO'];

const ONEX_BATTERY = [401, 402, 404, 405, 406, 407];
const ONEX2_BATTERY = [1161, 1476];
const PRO_BATTERY = [101, 102];
const TITAN_BATTERY = [925, 936];
const ONER_BATTERY = [979, 1047, 1057, 1058, 1059];
const ONERS_BATTERY = [1737, 1762, 1774, 1763, 1057, 1059, 1047]; // 1763 -> 电池+保护框（RS,367）
const ONERS_1Inch_BATTERY = [1914]; // 1763 -> 电池+保护框（RS,367）
const SPHERE_BATTERY = [1911];
const X3_BATTERY = [2109];
const ACE_BATTERY = [2652];

// product id, 隐藏电池产品名
const PRO_BATTERY_PRODUCTS = [106];
const ONEX_BATTERY_PRODUCTS = [139];
const TITAN_BATTERY_PRODUCTS = [219];

export const BATTERY_GROUP = [
  ...ONEX_BATTERY,
  ...ONEX2_BATTERY,
  ...PRO_BATTERY,
  ...TITAN_BATTERY,
  ...ONER_BATTERY,
  ...ONERS_BATTERY,
  ...ONERS_1Inch_BATTERY,
  ...SPHERE_BATTERY,
  ...X3_BATTERY,
  ...ACE_BATTERY,
];
export const BATTERY_ACCESSORY = [
  ...ONEX_BATTERY,
  ...ONEX2_BATTERY,
  ...ONER_BATTERY,
  ...ONERS_BATTERY,
  ...PRO_BATTERY,
  ...TITAN_BATTERY,
  ...ONERS_1Inch_BATTERY,
  ...SPHERE_BATTERY,
  ...X3_BATTERY,
  ...ACE_BATTERY,
];
export const CAMERA_GROUP = [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 15, 16, 17, 19, 21, 23, 25, 366];

// 获取电池对应的相机类型
function getBatteryTypeGroup(cid) {
  const typeGroup = [];

  if (ACE_BATTERY.includes(cid)) typeGroup.push('ace');
  if (ONEX_BATTERY.includes(cid)) typeGroup.push('onex');
  if (ONEX2_BATTERY.includes(cid)) typeGroup.push('onex2');
  if (X3_BATTERY.includes(cid)) typeGroup.push('onex3');
  if (PRO_BATTERY.includes(cid)) typeGroup.push('pro');
  if (TITAN_BATTERY.includes(cid)) typeGroup.push('titan');

  // 部分电池属于多个机型分类，例如：电池1057：oner和oners分类
  if (ONER_BATTERY.includes(cid)) typeGroup.push('oner');
  if (ONERS_BATTERY.includes(cid)) typeGroup.push('oners');

  if (ONERS_1Inch_BATTERY.includes(cid)) typeGroup.push('oners_1inch');

  if (SPHERE_BATTERY.includes(cid)) typeGroup.push('sphere');

  return typeGroup;
}

// 获取充电座对应相机类型
function getBatteryStationType(cid) {
  let type = '';
  switch (cid) {
    case 1162:
      type = 'onex2';
      break;
    case 403:
      type = 'onex';
      break;
    case 103:
      type = 'pro';
      break;
    case 935:
      type = 'titan';
      break;
    case 980:
      type = 'oner';
      break;
    case 1792:
      type = 'oners';
      break;
    case 2110:
      type = 'onex3';
      break;
    case 2653:
      type = 'ace';
      break;
    default:
      type = '';
  }
  return type;
}

// 获取相机类型
function getCameraType(pid, cid) {
  let type = '';
  switch (pid) {
    case 7:
      type = 'onex';
      break;
    case 6:
    case 399:
      type = 'pro';
      break;
    case 10:
    case 400:
      type = 'titan';
      break;
    case 12:
    case 21:
      type = 'oner';
      if ([721, 723, 724, 2577, 2578, 2579, 2580, 2581, 2582, 2583, 2584, 2585, 2586, 2587, 2588].includes(cid)) {
        type = 'onex';
      }
      if ([1454, 1455, 2565, 2566, 2567, 2568, 2569, 2570, 2571, 2572, 2573, 2574, 2575, 2576].includes(cid)) {
        type = 'onex2';
      }
      if ([2208, 2553, 2554, 2555, 2556, 2557, 2558].includes(cid)) {
        type = 'onex3';
      }
      if ([1967, 2559, 2560, 2561, 2562, 2563, 2564].includes(cid)) {
        type = 'oners_1inch';
      }
      break;
    case 23:
      if ([2234].includes(cid)) {
        type = 'onex3';
      }
      if ([2235].includes(cid)) {
        type = 'oners_1inch';
      }
      break;
    case 13:
      type = 'onex2';
      break;
    case 15:
    case 366: // ONERS主机套装
      type = 'oners';
      break;
    case 16:
      type = 'sphere';
      break;
    case 17: // ONERS1英寸
      type = 'oners_1inch';
      break;
    case 19:
      type = 'onex3';
      break;
    case 25:
      type = 'ace';
      break;

    default:
      type = '';
  }
  return type;
}

// 隐藏电池产品名
export function hideBatteryProductName(pid) {
  const group = [...PRO_BATTERY_PRODUCTS, ...ONEX_BATTERY_PRODUCTS, ...TITAN_BATTERY_PRODUCTS];
  return group.includes(pid);
}

// 判断电池规则
export function hasBatteryRules({ cartItems, country }) {
  const cameraGroup = [];
  const accessoryGroup = [];
  const batteryStationGroup = [];
  let batteryGroup = [];

  cartItems.forEach((item) => {
    const { productId, commodityId } = item;
    const camera = getCameraType(productId, commodityId);
    const batteryTypeGroup = getBatteryTypeGroup(commodityId);
    const batteryStationType = getBatteryStationType(commodityId);
    if (camera) {
      cameraGroup.push(camera);
    } else if (batteryTypeGroup[0]) {
      batteryGroup = batteryGroup.concat(batteryTypeGroup);
      batteryGroup = Array.from(new Set(batteryGroup));
    } else if (batteryStationType) {
      batteryStationGroup.push(batteryStationType);
    } else {
      accessoryGroup.push(item);
    }
  });

  const cameraLength = cameraGroup.length;
  const accessoryLength = accessoryGroup.length;
  const batteryLength = batteryGroup.length;

  const hasCamera = cameraLength > 0;
  const hasBattery = batteryLength > 0;
  const hasAccessory = accessoryLength > 0;

  const rules = {
    pass: true,
    onlyBattery: false,
  };

  // 大陆、香港、澳门可发货
  if (NORMAL_COUNTRY_CODE.includes(country.code)) return rules;

  // 不包含电池
  if (!hasBattery) return rules;

  // 包含电池 + 相机 判断是否存在相同的相机
  if (hasCamera) {
    let hasSameCamera = false;
    batteryGroup.forEach((o) => {
      if (cameraGroup.includes(o)) {
        hasSameCamera = true;
      }
    });
    rules.pass = hasSameCamera;
    return rules;
  }

  // 不包含相机 判断配件情况
  if (!hasCamera) {
    const onlyBattery = hasBattery && !hasCamera && !hasAccessory;

    // 只要包含配件 - 不可以发货
    if (hasAccessory) {
      rules.pass = false;
      return rules;
    }
    if (!hasAccessory) {
      // 只包含电池 - 可以发货
      if (onlyBattery) {
        rules.onlyBattery = onlyBattery;
        return rules;
      }
      // 包含与电池产品分类一致的充电座 - 可以发货
      let hasSameStation = false;
      batteryGroup.forEach((o) => {
        if (batteryStationGroup.includes(o)) {
          hasSameStation = true;
        }
      });
      rules.pass = hasSameStation;
      return rules;
    }
  }
}
